import { Center, Image } from "@chakra-ui/react"

import Icon from "components/UI/atoms/Icon"
import { IReservation } from "types/reservation"
import { IRoles } from "types/shared"





const renderStatusIcon = ({ statusId, actions, data, userRole }: any) => {
  let action: any = null

  if (statusId === 2) {
    action = actions.handleStartClick
  }

  if (statusId === 3) {
    action = actions.handleStopClick
  }

  if (statusId === 1) {
    action = actions.handleMoonClick
  }


  return (
    <Center
      w="40px"
      h="40px"
      borderRadius="50%"
      cursor="pointer"
      pointerEvents={userRole === IRoles.CASHIER ? "none" : "auto"}
      onClick={action ? () => action(data) : () => { }}
    >
      <Image style={{ maxWidth: "unset" }} src={data.statusImageUrl} />
    </Center>
  )
}

export const getInsideActions = ({
  handleStartClick,
  handleStopClick,
  handleViewClick,
  handleCancelClick,
  handleMoonClick,
  userRole
}: any) => [
    {
      key: "start",
      render: (data: IReservation) =>
        renderStatusIcon({
          statusId: data.statusId,
          actions: { handleStartClick, handleStopClick, handleMoonClick },
          data,
          userRole: userRole
        }),
    },
    {
      key: "view",
      render: (data: IReservation) => (
        <Center
          w="40px"
          h="40px"
          borderRadius="50%"
          backgroundColor="primary"
          onClick={() => handleViewClick(data)}
          cursor="pointer"
        >
          <Icon name="view" />
        </Center>
      ),
    },
    {
      key: "cancel",
      render: (data: IReservation) => {
        // const disableCancelAction = data.statusId !== 1
        const isQappUser = userRole && [IRoles.QAPP_ADMIN, IRoles.QAPP_MANAGER, IRoles.WASHER_ADMIN, IRoles.WASHER_MANAGER].includes(userRole);
        const isFinishedOrCancelled = data.statusId !== 4 && data.statusId !== 5 && data.statusId !== 3 && data.statusId !== 6
        const renderCancelIconColor = () => {
          if (isQappUser && data.statusId === 3 && data.webReservation) {
            return "var(--chakra-colors-icon_button_border_color)"
          } else if (isQappUser && isFinishedOrCancelled) {
            return "var(--chakra-colors-button_grey_bg)"
          } else {
            return "var(--chakra-colors-icon_button_border_color)"
          }
        }
        return (

          <Center onClick={() => handleCancelClick(data)} cursor="pointer" pointerEvents={(isQappUser && isFinishedOrCancelled) ? "all" : "none"}>
            <Icon
              name="close"
              iconStyles={{
                width: "24px",
                height: "24px",
                fill: renderCancelIconColor(),
              }}
            />
          </Center>

        )
      },
    },
  ]
